import { schema } from "normalizr";

const jobType = new schema.Entity(`job_types`);
const arrayOfJobTypes = [jobType];

export { jobType, arrayOfJobTypes };
